import { PILLAR } from "../../enums/metrics";
import type { MetricDef } from "./types";

/**
 * Content Fitness v1.2 family: the five weighted dimensions plus `voice_trust`,
 * the Client Tone-of-Voice dimension whose checklist is extended per run from
 * the run's TOV snapshot (see `TOV_DIMENSION_KEY`).
 */
export const CONTENT_FITNESS_METRICS = [
  {
    key: "human_first_content_quality",
    label: "Human-First Content Quality",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Whether the content is clear, useful, natural, trustworthy and written for humans first.",
  },
  {
    key: "content_design_orientation",
    label: "Content Design & Orientation",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Whether the page is structured so humans, search engines and AI systems can all understand it.",
  },
  {
    key: "ai_agent_readiness",
    label: "AI Agent Readiness",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Whether AI systems and agents can access, read, parse, cite and act on the page with the brand as the source.",
  },
  {
    key: "journey_usability_action",
    label: "Journey, Usability & Action",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Whether the page serves the right user at the right moment and makes the next useful step clear.",
  },
  {
    key: "brand_trust_consistency",
    label: "Brand, Trust & Consistency",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Whether the page feels credible, on-brand and consistent with active guidance.",
  },
  {
    key: "voice_trust",
    label: "Voice & Trust",
    pillar: PILLAR.CONTENT_FITNESS,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Client Tone-of-Voice dimension: credible, on-brand voice judged against the run's active TOV snapshot — its checklist is extended per run from that snapshot.",
  },
] as const satisfies readonly MetricDef[];
